// extracted by mini-css-extract-plugin
export default {"header-wrapper":"header_header-wrapper__h5E6a"};